import { createClient } from "@supabase/supabase-js";

// Environment-based configuration (NO HARDCODED KEYS)
// Works in both Vite (frontend) and Node.js (backend) environments
const supabaseUrl = 
  process.env.SUPABASE_URL ||           // Node.js backend (PM2)
  process.env.VITE_SUPABASE_URL ||      // Node.js with Vite env
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_URL); // Vite frontend

const supabaseAnonKey = 
  process.env.SUPABASE_ANON_KEY ||      // Node.js backend (PM2)
  process.env.VITE_SUPABASE_ANON_KEY || // Node.js with Vite env
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_ANON_KEY); // Vite frontend

// Validate required environment variables
if (!supabaseUrl) {
  throw new Error(
    'Missing Supabase URL. Please set SUPABASE_URL or VITE_SUPABASE_URL environment variable.'
  );
}

if (!supabaseAnonKey) {
  throw new Error(
    'Missing Supabase Anon Key. Please set SUPABASE_ANON_KEY or VITE_SUPABASE_ANON_KEY environment variable.'
  );
}

// Create Supabase client with proper auth configuration
export const masterSupabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    lock: false,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  global: {
    headers: {
      'X-Client-Info': 'clara360-master-client'
    }
  }
});

export default masterSupabase;

// Debug logging for auth state (only when explicitly enabled)
// Singleton check to prevent multiple logs during HMR (Hot Module Replacement)
let _debugLogged = false;
const isDebugEnabled = process.env.DEBUG_SUPABASE === 'true';

if (isDebugEnabled && !_debugLogged) {
  _debugLogged = true;
  const environment = typeof window !== 'undefined' ? 'Browser' : 'Node.js';
  console.log(`[Supabase Master Client] Initialized in ${environment} environment`);
  console.log('[Supabase Master Client] URL:', supabaseUrl);
  console.log('[Supabase Master Client] Key prefix:', supabaseAnonKey?.substring(0, 20) + '...');
}
